import { __decorate } from "tslib";
import lang from '@blade-sxp/portrait-management/lang/index';
import { Component, Vue, Prop } from 'vue-property-decorator';
import BlurPicture from '@blade/common/components/blur-picture/index.vue';
let default_1 = class default_1 extends Vue {
    imageUrls; // 图像地址
    maxCount; // 最大尺寸(张)
    maxSize; // 最大大小(M)
    disabled; // 是否禁用
    supportFormat; // 支持格式
    iconSize = 13;
    MB = 1024 * 1024;
    fileList = [];
    get fileListUrl() {
        return this.imageUrls;
    }
    /** 模糊尺寸 */
    get blurSize() {
        return this.privacyMode ? 6 : 0;
    }
    /** 是否开启隐私模式 */
    get privacyMode() {
        return localStorage.getItem('privacyMode') === 'true';
    }
    created() {
        this.fileList = this.imageUrls.map((iu) => {
            return {
                url: iu,
            };
        });
    }
    /**
     * file转换base64
     */
    convertBase64(file) {
        return new Promise((resolve) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = () => resolve(false);
        });
    }
    /**
     * 上传检测文件大小等
     */
    beforeUploadFunc(file) {
        let fileType = file.name.split('.').pop()?.toLocaleLowerCase();
        if (!this.supportFormat.split(' ').includes(`.${fileType}`)) {
            this.$message({
                showClose: true,
                type: 'error',
                message: this.$t('formatError').toString(),
                customClass: 'success-message',
            });
            return false;
        }
        if (file.size > this.maxSize * this.MB) {
            this.$message({
                showClose: true,
                type: 'error',
                message: this.$t('lessThanSizeMessage', { size: this.maxSize }).toString(),
                customClass: 'success-message',
            });
            return false;
        }
        return true;
    }
    /**
     * 更新图片地址
     */
    async updateImageUrlFunc(fileList) {
        let tmpBase64 = [];
        for (const file of fileList ?? this.fileList) {
            if (file.url && file.url.startsWith('data:image'))
                tmpBase64.push(file.url);
            else if (file.raw)
                tmpBase64.push(await this.convertBase64(file.raw));
        }
        this.$emit('update:imageUrls', tmpBase64);
    }
    /**
     * 文件更改
     */
    async fileChange(file, fileList) {
        if (this.beforeUploadFunc(file)) {
            this.fileList = fileList;
            this.updateImageUrlFunc(fileList);
        }
        else
            this.fileList = fileList.filter((f) => f !== file);
    }
    /**
     * 删除文件
     */
    handleFileRemove(file) {
        this.fileList = this.fileList.filter((f) => f !== file);
        this.updateImageUrlFunc();
    }
};
__decorate([
    Prop()
], default_1.prototype, "imageUrls", void 0);
__decorate([
    Prop({ default: 5 })
], default_1.prototype, "maxCount", void 0);
__decorate([
    Prop({ default: 5 })
], default_1.prototype, "maxSize", void 0);
__decorate([
    Prop({ default: false })
], default_1.prototype, "disabled", void 0);
__decorate([
    Prop({ default: '.bmp .jpg .jpeg .png' })
], default_1.prototype, "supportFormat", void 0);
default_1 = __decorate([
    Component({
        i18n: {
            messages: lang,
        },
        components: { BlurPicture },
    })
], default_1);
export default default_1;
